module.exports = __webpack_public_path__ + "gy.svg?f67dfeb2568434e36079f7bbf9721247";